<div class="loader-container">
    <app-loader *ngIf="loading == true"></app-loader>
    <section *ngIf="item">
        <div class="row">
            <div class="col-8">
                <div class="card">
                    <div class="card-header d-flex space-between">
                        <h5 class="card-title">
                            {{item['name']}}
                        </h5>
                        <div class="card-buttons">
                            <button (click)="openModal(item)" class="btn btn-link btn-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-pencil-square" viewBox="0 0 16 16">
                                    <path
                                        d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="card-body card-table">
                        <table class="table table-striped">
                            <tbody>
                                <tr>
                                    <td class="text-muted" width="220">Naam</td>
                                    <td>{{item['name']}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">EAN</td>
                                    <td>{{item['ean']}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Producttype</td>
                                    <td>{{item['type']}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Verzendcategorie</td>
                                    <td [ngSwitch]="item['shipping_category']">
                                        <span *ngSwitchCase="'category_a'">Categorie A (60)</span>
                                        <span *ngSwitchCase="'category_b'">Categorie B (40)</span>
                                        <span *ngSwitchCase="'category_c'">Categorie C (30)</span>
                                        <span *ngSwitchCase="'category_d'">Categorie D (25)</span>
                                        <span *ngSwitchDefault>Geen</span>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Korte omschrijving</td>
                                    <td>{{item['short_description']}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Lange omschrijving</td>
                                    <td>{{item['long_description']}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Copyright</td>
                                    <td>{{item['copyright']}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Uitgever</td>
                                    <td>{{item['publisher']}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Verkoop actief</td>
                                    <td>{{item['for_sale']}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Is demo</td>
                                    <td>{{item['is_demo']}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Prijs</td>
                                    <td>{{item['price']}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Gepubliceerd op</td>
                                    <td>{{item['first_published_date']}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Gemaakt op</td>
                                    <td>{{item['created_at']}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Gewijzigd op</td>
                                    <td>{{item['updated_at']}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Status</td>
                                    <td>{{item['status']}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Editie</td>
                                    <td>{{item['edition']}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Proeflicentie link</td>
                                    <td>
                                        <a *ngIf="item['trial_url']" href="{{item['trial_url']}}" target="_blank">{{item['trial_url']}}</a>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">EOL datum</td>
                                    <td>{{item['end_of_life_date']}}</td>
                                    <td></td>
                                </tr>

                                <tr>
                                    <td class="text-muted" width="220">Methodes</td>
                                    <td>
                                        <ng-container *ngFor="let course of productCourses"><span
                                                class="mr-2">{{course['title']}} <svg
                                                    (click)="removeCourse(item, course)"
                                                    xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="bi bi-trash cursor-pointer"
                                                    viewBox="0 0 16 16">
                                                    <path
                                                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                    <path
                                                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                </svg></span></ng-container>
                                    </td>
                                    <td>
                                        <button (click)="addRelation(courseModal)" class="btn btn-link btn-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd"
                                                    d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                            </svg>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Auteurs</td>
                                    <td>
                                        <ng-container *ngFor="let author of productAuthors"><span
                                                class="mr-2">{{author['name']}} <svg
                                                    (click)="removeAuthor(item, author)"
                                                    xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="bi bi-trash cursor-pointer"
                                                    viewBox="0 0 16 16">
                                                    <path
                                                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                    <path
                                                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                </svg></span></ng-container>
                                    </td>
                                    <td><button (click)="addRelation(authorModal)" class="btn btn-link btn-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd"
                                                    d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                            </svg>
                                        </button></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Vakken</td>
                                    <td>
                                        <ng-container *ngFor="let subject of productSubjects"><span
                                                class="mr-2">{{subject['name']}} <svg
                                                    (click)="removeSubject(item, subject)"
                                                    xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="bi bi-trash cursor-pointer"
                                                    viewBox="0 0 16 16">
                                                    <path
                                                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                    <path
                                                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                </svg></span></ng-container>
                                    </td>
                                    <td><button (click)="addRelation(subjectModal)" class="btn btn-link btn-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd"
                                                    d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                            </svg>
                                        </button></td>
                                </tr>
                                <tr>
                                    <td class="text-muted" width="220">Niveau's</td>
                                    <td>
                                        <ng-container *ngFor="let studyLevel of productStudyLevels"><span
                                                class="mr-2">{{studyLevel['name']}} <svg
                                                    (click)="removeStudyLevel(item, studyLevel)"
                                                    xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="bi bi-trash cursor-pointer"
                                                    viewBox="0 0 16 16">
                                                    <path
                                                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                    <path
                                                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                </svg></span></ng-container>
                                    </td>
                                    <td><button (click)="addRelation(studyLevelModal)" class="btn btn-link btn-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd"
                                                    d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                            </svg>
                                        </button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="card mb-4">
                    <div class="card-header d-flex space-between">
                        <h5 class="card-title">
                            Modules
                        </h5>
                        <div class="card-buttons">
                            <button (click)="addModule()" class="btn btn-link btn-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                    class="bi bi-plus-lg" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                        d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="card-body card-table">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col" colspan="2">Naam</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let chapter of productChapters">
                                    <td>
                                        {{chapter['title']}}
                                    </td>
                                    <td style="text-align:right;padding-right:40px;">
                                        <svg (click)="removeChapter(item, chapter)" xmlns="http://www.w3.org/2000/svg"
                                            width="16" height="16" fill="currentColor"
                                            class="bi bi-trash cursor-pointer" viewBox="0 0 16 16">
                                            <path
                                                d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                            <path
                                                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                        </svg>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card mb-4">
                    <div class="card-header d-flex space-between">
                        <h5 class="card-title">
                            Afbeeldingen
                        </h5>
                        <div class="card-buttons">
                            <!-- The hidden file input element -->
                            <input type="file" accept="image/*" #fileInput style="display: none"
                                (change)="onFileSelected($event)">

                            <!-- Your button -->
                            <button class="btn btn-link btn-icon" (click)="triggerFileInput()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                    class="bi bi-plus-lg" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                        d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                </svg>
                            </button>

                        </div>
                    </div>
                    <div class="card-body card-table">
                        <div (cdkDropListDropped)="drop($event)" cdkDropList class="photo-list">
                            <div class="photo-box" cdkDrag *ngFor="let image of productImages">
                                <div class="cursor-move">
                                    <img (click)="openImagePreview(image['id'])" class="thumb"
                                        [src]="productIdToUrl(image['id'])">
                                </div>
                                <div class="cursor-pointer p-2" (click)="removeImage(image)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-trash cursor-pointer" viewBox="0 0 16 16">
                                        <path
                                            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                        <path
                                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                    </svg>
                                </div>
                            </div>
                            <div *ngIf="productImages && productImages.length == 0">
                                <small>Nog geen afbeeldingen geüpload.</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>


<ng-template #studyLevelModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">Niveau toevoegen</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x"
                viewBox="0 0 16 16">
                <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
        </button>
    </div>
    <div class="modal-body">
        <table class="table">
            <thead>
                <tr>
                    <th scope="col" [width]="150">Selecteer</th>
                    <th scope="col">Naam</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let studyLevel of studyLevels">
                    <td>
                        <input type="checkbox" [value]="studyLevel['id']" (change)="onCheckboxChange($event)"
                            [disabled]="isStudyLevelSelected(studyLevel)" />
                    </td>
                    <td>
                        {{ studyLevel['name'] }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="submitSelectedStudyLevels(item)">Toevoegen</button>
    </div>
</ng-template>


<ng-template #subjectModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">Vak toevoegen</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg"
                viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                    d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
            </svg>
        </button>
    </div>
    <div class="modal-body">
        <table class="table">
            <thead>
                <tr>
                    <th scope="col" colspan="2">Naam</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let subject of subjects">
                    <td>
                        {{subject['name']}}
                    </td>
                    <td>
                        <svg (click)="addSubject(item, subject)" xmlns="http://www.w3.org/2000/svg" width="16"
                            height="16" fill="currentColor" class="plusButton bi bi-plus-lg" viewBox="0 0 16 16">
                            <path fill-rule="evenodd"
                                d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                        </svg>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>

<ng-template #courseModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">Methode toevoegen</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x"
                viewBox="0 0 16 16">
                <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
        </button>
    </div>
    <div class="modal-body">
        <table class="table">
            <thead>
                <tr>
                    <th scope="col" colspan="2">Naam</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let course of courses">
                    <td>
                        {{course['title']}}
                    </td>
                    <td>
                        <svg (click)="addCourse(item, course)" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                            fill="currentColor" class="plusButton bi bi-plus-lg" viewBox="0 0 16 16">
                            <path fill-rule="evenodd"
                                d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                        </svg>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>

<ng-template #authorModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">Auteur toevoegen</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x"
                viewBox="0 0 16 16">
                <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
        </button>
    </div>
    <div class="modal-body">
        <table class="table">
            <thead>
                <tr>
                    <th scope="col" colspan="2">Naam</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let author of authors">
                    <td>
                        {{author['name']}}
                    </td>
                    <td>
                        <svg (click)="addAuthor(item, author)" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                            fill="currentColor" class="plusButton bi bi-plus-lg" viewBox="0 0 16 16">
                            <path fill-rule="evenodd"
                                d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                        </svg>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>
